export default {
    header:{
        addWidget: {
            title: "Ajoute widget",
            button: {
                title: "Ajouter un widget",
                hide: "Masquer widgets ajoutés"
            }
        },
        datePicker:{
            title: "Plage de dates",
            options: {
                range: "Gamme",
                today: "Aujourd'hui",
                yesterday: "Hier",
                last7Days: "Derniers 7 jours",
                thisWeek: "Cette semaine",
                last30Days: "Derniers 30 jours",
                thisMonth: "Ce mois-ci",
                lastYear: "L'année dernière",
                thisYear: "Cette année",
            },
            compareTo: {
                title: "Comparer avec",
                previousPeriod: "Période précédente",
                previousYear: "Année précédente"
            },
            cancel: "Annuler",
            apply: "Appliquer",
            wrongStartDate: "La date de début ne peut pas être antérieure à %{date}."
        },
        warning: {
            tooltip: "Cliquez pour plus d'informations"
        },
        connection: {
            up: "connexion ÉTABLIE",
            down: "connexion PERDUE"
        }
    },
    widget:{
        options:{
            move: "Bouge",
            delete: "Effacer"
        },
        moreInfo: "Plus d'information",
        noData:"Aucune donnée disponible pour ce widget.",
        noDataForPill: "Aucune donnée disponible pour %{pill}.",
        sync:{
            object: "Objets",
            problem: "Problème",
            nothing: "Pas de serrures d'objets, beau travail !"
        },
        search:{
            terms:{
                title: "Terme",
                value: "# Recherches"
            },
            topProduct: {
                tableTitle: "Produit"
            }
        },
        topProducts: {
            tableTitle: "Product"
        },
        topClients: {
            tableTitle: "Client"
        },
        filters: {
            logins: "Logins",
            sales: "Ventes",
            orders: "Commandes",
            views: "Vues"
        },
        pageviews: {
            name: "Pages vues",
            info: "Affiche les pages les plus visitées avec des filtres pour l'URL, le compte et le nombre de vues"
        },
        pageVisits: {
            name: "Dernières visites",
            info: "Affiche les visites de page les plus récentes avec des filtres pour l'URL et le compte"
        }
    },
    footer:{
        cancel: "Annuler",
        save: "Sauvegarder les changements"
    }
}